import { KEY_DISABLE_NOTIFICATIONS } from '../notificationQueue/Queue';

export function shouldDisableNotifications() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(KEY_DISABLE_NOTIFICATIONS) === 'true';
}
